import { graphql } from "@/graphql/codegen"

graphql(`
  fragment EntityLockBaseFields on EntityLock {
    id
    entityType
    entityId
    lockedByUserId
    lockedByUserName
    createdOn
    expiredOn
  }
`)
